import { HttpStatusCode } from "axios";
import { TFunction } from "i18next";

import { errors } from "../../constants";
import { ResponseStatusEnum } from "../../enums";
import { IApiError, TTranslationParams } from "../../models";
import { unique } from "../array.helpers";
import { Log } from "../log.helpers";

export const getNotAuthorizedError = (message?: string): IApiError => ({
  message,
  translationKey: errors.common.authenticationError,
  status: ResponseStatusEnum.Error,
});

export const getForbiddenResponseError = (message?: string): IApiError => ({
  message,
  translationKey: errors.common.forbiddenResponseStatus,
  status: ResponseStatusEnum.Error,
});

export const getForbiddenResponseByPermissionError = (
  message?: string,
): IApiError => ({
  message,
  translationKey: errors.common.forbiddenResponseByPermission,
  status: ResponseStatusEnum.Error,
});

export const normalizeApiError = ({
  apiError,
  fallbackTranslationKey,
}: {
  apiError?: IApiError;
  fallbackTranslationKey?: string;
}): IApiError => ({
  message: apiError?.message || "Api error",
  translationKey: apiError?.translationKey || fallbackTranslationKey,
  translationParams: apiError?.translationParams,
  status: ResponseStatusEnum.Error,
  debugInfo: apiError?.debugInfo || apiError?.cause,
});

export const EMPTY_RESPONSE_ERROR: IApiError = {
  message: "Invalid response (empty response)",
  translationKey: errors.common.emptyApiResponse,
  status: ResponseStatusEnum.Error,
};

export const transformApiCrudErrorForToast = ({
  errorsNormalized,
  tFunction,
  fallbackTranslationKey,
  fallbackTranslationParams,
}: {
  errorsNormalized: string[] | undefined;
  tFunction: TFunction;
  fallbackTranslationKey?: string;
  fallbackTranslationParams?: TTranslationParams;
}): string => {
  const errorsNotEmpty = errorsNormalized?.filter(x => x);

  if (errorsNotEmpty?.length) {
    return unique(errorsNotEmpty).join(",");
  }

  if (fallbackTranslationKey) {
    return tFunction(fallbackTranslationKey, fallbackTranslationParams);
  }

  return tFunction(errors.common.errorFetchingApiData);
};

export const logApiError = (status: number, e: Error): void => {
  Log[status !== HttpStatusCode.Conflict ? "warn" : "debug"](
    "Raw api exception:",
    e,
  );
};

export const createApiErrorWithTranslation = ({
  message,
  translationKey,
}: {
  message: string | undefined;
  translationKey: string;
}): IApiError => ({
  message,
  translationKey,
  status: ResponseStatusEnum.Error,
});
